import React from "react";
import {
  Box,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  FormLabel,
  Checkbox,
  Typography,
} from "@material-ui/core";
import { withSnackbar } from "notistack";
import { isMobile } from "react-device-detect";
//Obtiene la url del proxie para los casos donde se invocan servicios por http
const proxieURL = process.env.REACT_APP_PROXIE;

//Nombre de las capas del mapa que utiliza el componente
var layerNames = {
  Metereologico: "radarImages",
  Nubosidad: "rgbClouds",
  TopNubes: "topClouds",
};
//Configuración de las capas del mapa del componente
var layers = {
  rgbClouds: {
    layerUpdate: null,
    layerAnimation: null,
    layerAnimationDuration: 100,
    layerUpdateTime: 1 * 60 * 60 * 1000,
  },
  topClouds: {
    layerUpdate: null,
    layerAnimation: null,
    layerAnimationDuration: 100,
    layerUpdateTime: 1 * 60 * 60 * 1000,
  },
  radarImages: {
    layerUpdate: null,
    layerAnimation: null,
    layerAnimationDuration: 500,
    layerUpdateTime: 1 * 60 * 60 * 1000,
  },
};

//Componente Radar Metereológico
class SateliteImages extends React.Component {
  //Definición del estado inicial del componente
  constructor(props) {
    super(props);
    this.state = {
      imagenRGB: "rgb0",
      topCloud: "top0",
      radarMetUltimaHora: false,
      radarImages: [],
      rgbData: [],
      topCloudData: [],
    };
  }

  //Agrega una imagen al mapa
  addImageLayer = (layerId, imageUrl) => {
    var tipos = this.getTypes();
    var image = new this.props.esri.MapImage({
      extent: tipos[layerId],
      href: imageUrl,
    });

    let layer = this.props.mapView.getLayer(layerId);
    if (layer) {
      layer.addImage(image);
      var images = layer.getImages();
      if (images.length >= 3)
        this.props.mapView.getLayer(layerId).removeImage(images[0]);
    }
  };

  //Establece la configuración para la animación de las imagenes de la capa
  animateLayer = (layerId, prev, min, max, animationDuration, images) => {
    var tipos = {
      topClouds: ["TopClouds/OR_ABI.", ".goes-16.tope_nubes.png"],
      rgbClouds: ["RGBClouds/", ".goes-16.rgb_ch14.jpg"],
    };

    var baseUrl = "http://rmgir.proyectomesoamerica.org/GOES16/";
    var next = prev < max - 1 ? prev + 1 : min;

    if (layerId === layerNames.Metereologico) {
      this.addImageLayer(layerId, images[next]);
    } else {
      this.addImageLayer(
        layerId,
        baseUrl + tipos[layerId][0] + images[next] + tipos[layerId][1]
      );
    }

    if (layers[layerId]["layerAnimation"])
      clearTimeout(layers[layerId]["layerAnimation"]);
    layers[layerId]["layerAnimation"] = window.setTimeout(() => {
      this.animateLayer(layerId, next, min, max, animationDuration, images);
    }, layers[layerId]["layerAnimationDuration"]);
  };

  //Establece el estado del componente en caso de error en la llamada del servicio
  getDummyRadaData = () => {
    this.props.enqueueSnackbar("Error al obtener los datos del servicio", {
      variant: "warning",
    });

    this.setState({
      radarImages: [],
    });
  };

  //Abre nueva ventana con la url del sitio indicado
  openSite = (site) => {
    window.open(site, "_blank");
  };

  //Obtiene los puntos del serivicio de Radar Metereológico
  getRadarData = async () => {
    let layer = this.props.moduleLayers.find(
      (l) => l.nombre === layerNames.Metereologico
    );
    var radarUrl = `${proxieURL}${layer.url}`;

    const res = await fetch(radarUrl, {
      method: "GET",
    }).catch((err) => {
      this.getDummyRadaData();
    });
    if (res) {
      if (res.status === 200) {
        let data = await res.text();
        data = data.split("\n");
        this.setState(
          {
            radarImages: data,
          },
          () => {
            this.animateLayer(
              layerNames.Metereologico,
              0,
              0,
              data.length,
              layers[layerNames.Metereologico]["layerAnimationDuration"],
              data
            );
          }
        );
      } else {
        this.getDummyRadaData();
      }
    }
  };

  //Establece el estado del componente en caso de error en la llamada del servicio
  getDummyRGBCloudData = () => {
    this.props.enqueueSnackbar("Error al obtener los datos del servicio", {
      variant: "warning",
    });

    this.setState({
      rgbData: [],
    });
  };

  //Obtiene losdatos del serivicio de Imágenes RGB
  getRGBCloudData = async () => {
    let layer = this.props.moduleLayers.find(
      (l) => l.nombre === layerNames.Nubosidad
    );
    var radarUrl = `${proxieURL}${layer.url}`;

    const res = await fetch(radarUrl, {
      method: "GET",
    }).catch((err) => {
      this.getDummyRGBCloudData();
    });
    if (res) {
      if (res.status === 200) {
        let data = await res.text();
        data = data.split("\n");
        let period = parseInt(this.state.imagenRGB.replace("rgb", ""));

        this.setState(
          {
            rgbData: data,
          },
          () => {
            this.animateLayer(
              layerNames.Nubosidad,
              data.length - 4 * period,
              data.length - 4 * period,
              data.length,
              layers[layerNames.Nubosidad]["layerAnimationDuration"],
              data
            );
          }
        );
      } else {
        this.getDummyRGBCloudData();
      }
    }
  };

  //Establece el estado del componente en caso de error en la llamada del servicio
  getDummyTopeCloudData = () => {
    this.props.enqueueSnackbar("Error al obtener los datos del servicio", {
      variant: "warning",
    });
    this.setState({
      rgbData: [],
    });
  };

  //Obtiene losdatos del serivicio de Tope de Nubes
  getTopeCloudData = async () => {
    let layer = this.props.moduleLayers.find(
      (l) => l.nombre === layerNames.TopNubes
    );
    var radarUrl = `${proxieURL}${layer.url}`;

    const res = await fetch(radarUrl, {
      method: "GET",
    }).catch((err) => {
      this.getDummyTopeCloudData();
    });
    if (res) {
      if (res.status === 200) {
        let data = await res.text();
        data = data.split("\n");
        let period = parseInt(this.state.topCloud.replace("top", ""));

        this.setState(
          {
            topCloudData: data,
          },
          () => {
            this.animateLayer(
              layerNames.TopNubes,
              data.length - 4 * period,
              data.length - 4 * period,
              data.length,
              layers[layerNames.TopNubes]["layerAnimationDuration"],
              data
            );
          }
        );
      } else {
        this.getDummyTopeCloudData();
      }
    }
  };

  //Maneja los eventos de cambio de estado del los controles option box de imagenes RGB
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      if (this.state.topCloud !== "top0") this.props.setMarqueeNubesState(true);
      else this.props.setMarqueeNubesState(false);
      if (name === "imagenRGB") {
        let layer = this.props.mapView.getLayer(layerNames.Nubosidad);
        layer.setVisibility(value !== "rgb0");
        if (value !== "rgb0") {
          this.getRGBCloudData();
        } else {
          clearTimeout(layers[layerNames.Nubosidad]["layerAnimation"]);
        }
      } else if (name === "topCloud") {
        let layer = this.props.mapView.getLayer(layerNames.TopNubes);
        layer.setVisibility(value !== "top0");
        if (value !== "top0") {
          this.getTopeCloudData();
        } else {
          clearTimeout(layers[layerNames.TopNubes]["layerAnimation"]);
        }
      }
    });
  };

  //Maneja los eventos de cambio de estado del los controles option box de Tope de Nubes
  handleChangeCheck = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked }, () => {
      if (name === "radarMetUltimaHora") {
        let layer = this.props.mapView.getLayer(layerNames.Metereologico);
        layer.setVisibility(checked);
        if (checked) {
          this.getRadarData();
        } else {
          clearTimeout(layers[layerNames.Metereologico]["layerAnimation"]);
        }
      }
    });
  };

  //Obtiene la configuración para los tipos de imágenes
  getTypes = () => {
    let tipos = {
      topClouds: new this.props.esri.Extent({
        xmax: -44.5,
        xmin: -122.5,
        ymax: 35,
        ymin: -2,
        spatialReference: new this.props.esri.SpatialReference(4326),
      }),
      rgbClouds: new this.props.esri.Extent({
        xmax: -78.9325,
        xmin: -125.19056,
        ymax: 34.7925,
        ymin: 6.295,
        spatialReference: new this.props.esri.SpatialReference(4326),
      }),
      radarImages: new this.props.esri.Extent({
        xmax: -98.128231,
        xmin: -99.695687,
        ymax: 19.935281,
        ymin: 18.755601,
        spatialReference: new this.props.esri.SpatialReference(4326),
      }),
    };

    return tipos;
  };

  //Render del componente inicial
  render() {
    let variant = isMobile ? "caption" : "body2";
    const { imagenRGB, topCloud, radarMetUltimaHora } = this.state;
    return (
      <Box>
        <Typography variant={variant} display="inline" color="primary">
          Nubosidad{" "}
        </Typography>
        <a
          href="http://www.lanot.unam.mx/"
          color="primary"
          target="_blank"
          rel="noreferrer"
        >
          <Typography variant="caption">(LANOT)</Typography>
        </a>
        <Box p={2}>
          <FormControl component="fieldset" size="small">
            <FormLabel component="legend">
              <Typography variant="body2">Imágenes RGB</Typography>
            </FormLabel>
            <RadioGroup
              aria-label="gender"
              name="imagenRGB"
              value={imagenRGB}
              onChange={this.handleChange}
              size="small"
            >
              <FormControlLabel
                value="rgb6"
                control={<Radio size="small" />}
                label={
                  <Typography variant="caption">Últimas 6 horas</Typography>
                }
                size="small"
              />
              <FormControlLabel
                value="rgb12"
                control={<Radio size="small" />}
                label={
                  <Typography variant="caption">Últimas 12 horas</Typography>
                }
              />
              <FormControlLabel
                value="rgb24"
                control={<Radio size="small" />}
                label={
                  <Typography variant="caption">Últimas 24 horas</Typography>
                }
              />
              <FormControlLabel
                value="rgb48"
                control={<Radio size="small" />}
                label={
                  <Typography variant="caption">Últimas 48 horas</Typography>
                }
              />
              <FormControlLabel
                value="rgb0"
                control={<Radio size="small" />}
                label={<Typography variant="caption">Ninguno</Typography>}
              />
            </RadioGroup>
          </FormControl>
        </Box>
        <Box p={2}>
          <FormControl component="fieldset" size="small">
            <FormLabel component="legend">
              <Typography variant="body2">Tope de nubes</Typography>
            </FormLabel>
            <RadioGroup
              aria-label="gender"
              name="topCloud"
              value={topCloud}
              onChange={this.handleChange}
            >
              <FormControlLabel
                value="top6"
                control={<Radio size="small" />}
                label={
                  <Typography variant="caption">Últimas 6 horas</Typography>
                }
              />
              <FormControlLabel
                value="top12"
                control={<Radio size="small" />}
                label={
                  <Typography variant="caption">Últimas 12 horas</Typography>
                }
              />
              <FormControlLabel
                value="top24"
                control={<Radio size="small" />}
                label={
                  <Typography variant="caption">Últimas 24 horas</Typography>
                }
              />
              <FormControlLabel
                value="top48"
                control={<Radio size="small" />}
                label={
                  <Typography variant="caption">Últimas 48 horas</Typography>
                }
              />
              <FormControlLabel
                value="top0"
                control={<Radio size="small" />}
                label={<Typography variant="caption">Ninguno</Typography>}
              />
            </RadioGroup>
          </FormControl>
        </Box>
        <Typography color="primary" display="inline">
          Radar Meteorológico{" "}
        </Typography>
        <a
          href="https://data.sacmex.cdmx.gob.mx/aplicaciones/radar-meteorologico/"
          color="primary"
          target="_blank"
          rel="noreferrer"
        >
          <Typography variant="caption">(SACMEX)</Typography>
        </a>
        <Box p={2}>
          <FormControl component="fieldset" size="small">
            <FormLabel component="legend">
              <Typography variant="body2">CDMX</Typography>
            </FormLabel>

            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={radarMetUltimaHora}
                  onChange={this.handleChangeCheck}
                  name="radarMetUltimaHora"
                  color="primary"
                />
              }
              label={<Typography variant="caption">Última hora</Typography>}
            />
          </FormControl>
        </Box>
      </Box>
    );
  }
}

export default withSnackbar(SateliteImages);
